<template>
  <div :class="classes()">
    <Row verticalCenter>
      <Col :xs="6" :l="4">
        <div :class="`${el}__lineChart`">
          <div
            :class="`${el}__lineChartProgress ${el}__lineChartProgress--supportWarning`"
            :style="`width: ${desiredValueInPercent}%`"
          />
        </div>
        <strong v-if="!$matchMedia.l">
          <CountUp :end="desiredValue" suffix=" €" />
          {{ $t('perYear.plain') }}
        </strong>
      </Col>
      <Col v-if="$matchMedia.l" :xs="4" :l="4">
        <div :class="`${el}__item ${el}__item--supportWarning`">
          <Copy v-if="$matchMedia.l" element="div" noWrap>
            {{ $t('cs.analysis.budgetPackage.desired.short') }}
          </Copy>
          <Copy element="div" bold noWrap>
            <CountUp :end="desiredValue" suffix=" €" />
            von {{ $t('price', { value: formatNumber(totalPerYear, 0) }) }}
          </Copy>
        </div>
      </Col>
      <Col :xs="6" :l="4" right>
        <Button
          :label="
            $t(`cs.analysis.budgetPackage.applications.cta${!$matchMedia.l ? '.short' : ''}`, {
              value: careServiceCareLevel !== careLevel ? 0 : countDesiredValues,
            })
          "
          :href="ROUTE_APPLICATIONS"
          :disabled="countDesiredValues === 0 || careServiceCareLevel !== careLevel"
          @click="onTrackingClick"
          small
          expand
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import CountUp from '@/objects/CountUp';
import Button from '@/objects/Button';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import mixin from '@/mixins/careService';

import { ROUTE_APPLICATIONS } from '@/constants/routes';

export default {
  name: 'CareServiceBudgetPackageBar',
  props: {},
  mixins: [mixin],
  components: {
    Copy,
    CountUp,
    Button,
    Row,
    Col,
  },
  data() {
    return {
      ROUTE_APPLICATIONS,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}__bar`]: true,
        };
      },
    };
  },
  methods: {
    onTrackingClick() {
      this.$emit(
        'onTrackingClick',
        '-Leistung-Beantragen_btn-' +
          this.$t(`cs.analysis.budgetPackage.applications.cta`) +
          '_sticky',
        'button'
      );
    },
  },
};
</script>
